import { Text } from "@bps/fluent-ui";

interface CommaSeparatedListValueCountProps {
  value?: string;
}

export const CommaSeparatedListValueCount: React.FC<CommaSeparatedListValueCountProps> = ({
  value
}) => {
  const values =
    value
      ?.split(",")
      .map(x => x.trim())
      .filter(x => x.length > 0) ?? [];

  const suffix = values.length !== 1 ? "values" : "value";

  return (
    <Text variant="small">
      {values.length} {suffix}
    </Text>
  );
};
